import { Pipe, PipeTransform } from '@angular/core';
import { getLocale } from '@lib/i18n';
import { ITableData, TranslationObjectType } from '@reports/report/config-report.interface';
import { SUPPORTED_LANGUAGES } from '@lib/supported-languages';

@Pipe({ name: 'secondaryKeyPipe' })
export class SecondaryKeyPipe implements PipeTransform {
  public currentLanguage: keyof typeof SUPPORTED_LANGUAGES = getLocale() as keyof typeof SUPPORTED_LANGUAGES;

  public transform(data: ITableData, secondaryKeysArray: string[], nullString: string | TranslationObjectType): string {
    for (const key of secondaryKeysArray) {
      if (data[key]) return data[key];
    }

    return nullString ? (nullString[this.currentLanguage] ? nullString[this.currentLanguage] : nullString) : '--';
  }
}
